export const dimensions = [
  'directness',
  'avoidance',
  'conflictHeat',
  'socialControl',
  'emotionalVolatility',
  'repairIntent',
  'boundaryFirmness',
  'memeDefense',
  'impulsiveness',
  'chaosAppetite'
] as const;

export type Dimension = typeof dimensions[number];
export type ScoreVector = Record<Dimension, number>;

export const neutralScoreVector: ScoreVector = {
  directness: 50,
  avoidance: 50,
  conflictHeat: 50,
  socialControl: 50,
  emotionalVolatility: 50,
  repairIntent: 50,
  boundaryFirmness: 50,
  memeDefense: 50,
  impulsiveness: 50,
  chaosAppetite: 50
};
